import { apiClient } from '@/lib/api-client';
import { API_ROUTES } from '@/lib/api-config';
import type { Flash } from '@/types/flash.types';

/**
 * Get all flash messages
 */
export const getAllFlashes = async (): Promise<Array<Flash>> => {
  return apiClient.get<Array<Flash>>(API_ROUTES.FLASHES);
};

/**
 * Get currently active flash messages
 * (where current date is between start_date and end_date)
 */
export const getActiveFlashes = async (): Promise<Array<Flash>> => {
  return apiClient.get<Array<Flash>>(`${API_ROUTES.FLASHES}?active=true`);
};

/**
 * Get a single flash by ID
 */
export const getFlashById = async (id: string): Promise<Flash> => {
  return apiClient.get<Flash>(API_ROUTES.FLASH_BY_ID(id));
};
